import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';
import { Transition } from 'react-transition-group';

const TIMEOUT = 250;

const transitionStyles = {
    entering: {
        maxHeight: '100%',
        transition: `max-height ${ TIMEOUT }ms`
    },
    entered: {
        maxHeight: 0
    },
    exiting: {
        transition: `max-height ${ TIMEOUT}ms`,
        maxHeight: '100%'
    }
};
const AccordionCollapse = ({ children, mods={}, mix={}, collapsed }) => {
    const { className } = useMods(AccordionCollapse, { mix: { ...mix, collapsed }, mods }, true);

    return (
        <div
            className={ className }
        >
            { children }
        </div>
    );
};

AccordionCollapse.displayName = 'Accordion__Collapse';

AccordionCollapse.propTypes = {
    children: PropTypes.node,
    isAcitve: PropTypes.string,
    mix: PropTypes.object,
    mods: PropTypes.object
};

export default AccordionCollapse;
